import {
    FETCH_BLOCKED_USERS,
    FETCH_BLOCKED_USERS_SUCCESS,
    FETCH_BLOCKED_USERS_FAILED,
    BLOCK_USER,
    UNBLOCK_USER
  } from "../store/types";

  const INITIAL_STATE = {
    list: [],
    loading: false,
    error: {
      flag: false,
      msg: null
    }
  }
  
  export const blockreducer = (state = INITIAL_STATE, action) => {
    switch (action.type) {
      case FETCH_BLOCKED_USERS:
        return {
          ...state,
          loading: true
        };
      case FETCH_BLOCKED_USERS_SUCCESS:
        return {
          ...state,
          list: action.payload,
          loading: false
        };
      case FETCH_BLOCKED_USERS_FAILED:
        return {
          ...state,
          list: [],
          loading: false,
          error: {
            flag: true,
            msg: action.payload
          }
        };
      case BLOCK_USER:
        return state;
      case UNBLOCK_USER:
        return state;
      default:
        return state;
    }
  };
